import { useContext, useEffect, useState } from "react";
import logo from "../../../assets/logo.png";
import useGetRecommendations from "../../Hooks/use-get-recommendations";
import DataContext from "../../store/data-context";
import styles from "./AvailabilityCheck.module.css";
import DropInput from "./DropInput";
import MapSelector from "./MapSelector";

export default function AvailabilityCheck({
    splashIsActive,
    setSplashIsActive,
}) {
    const [isMapping, setIsMapping] = useState(false);

    const {
        location: selectedLocation,
        setLocation: setSelectedLocation,
        availableServices,
        checkAvailability,
        setInHelp,
        isSatellite,
        setIsSatellite,
        triggerInputHouseNumber,
        setTriggerInputHouseNumber,
    } = useContext(DataContext);

    useEffect(() => {
        if (splashIsActive) {
            setTimeout(() => {
                setSplashIsActive(false);
                setInHelp({
                    title: "Odabir adrese",
                    description:
                        "Da biste započeli, molimo vas da kliknete u tražilicu. Upišite svoju adresu, a zatim odaberite jednu od ponuđenih adresa iz rezultata pretraživanja.",
                    active: false,
                    quickTip: true,
                    questions: [],
                });
            }, 1850);
        } else {
            setInHelp({
                title: "Odabir adrese",
                description:
                    "Da biste započeli, molimo vas da kliknete u tražilicu. Upišite svoju adresu, a zatim odaberite jednu od ponuđenih adresa iz rezultata pretraživanja.",
                active: false,
                quickTip: true,
                questions: [],
            });
        }
    }, []);

    const {
        recommendations,
        isLoading,
        setIsLoading,
        fetchRecommendations,
        setRecommendations,
    } = useGetRecommendations();

    return (
        <div className={styles.container}>
            {
                // SPLASH SCREEEN
                /*splashIsActive && (
                <div className={styles.splash}>
                    <img className={styles.logo} src={logo} />
                    <div className={styles[`splash-title`]}>
                        Provjera <br /> dostupnosti
                    </div>
                </div>
            )*/
            }
            <DropInput
                setSelectedLocation={setSelectedLocation}
                recommendations={recommendations}
                fetchRecommendations={fetchRecommendations}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                setIsMapping={setIsMapping}
                selectedLocation={selectedLocation}
                setInHelp={setInHelp}
                setRecommendations={setRecommendations}
                triggerInputHouseNumber={triggerInputHouseNumber}
                setTriggerInputHouseNumber={setTriggerInputHouseNumber}
            />

            <MapSelector
                isSatellite={isSatellite}
                setIsSatellite={setIsSatellite}
                location={selectedLocation}
                setLocation={setSelectedLocation}
            />
        </div>
    );
}
